export const defaultClipboardContent = '';
export const tabKeySubTabKeySeparator = '🖤';

export enum APPLICATION_STATE {
    APPLICATION_STARTED = 'APPLICATION_STARTED',
    UNAUTHORISED_READY = 'UNAUTHORISED_READY',
    AUTHORISED_READY = 'AUTHORISED_READY',
}
export enum HTMLButtonType {
    button = 'button',
    submit = 'submit',
    reset = 'reset',
}


export enum SortDirections {
    DESCEND = 'desc',
    ASCEND = 'asc',
}


export const DefaultSortByValue = 'id';

export enum SortDirectionsAPI {
    DESC = 'desc',
    ASC = 'asc',
}

export const emptyString = '';

export enum DetailsScreensNames {
    cardDetails = 'cardDetails',
    companyDetails = 'companyDetails',
    beneficiaryDetails = 'beneficiaryDetails',
    employeeDetails = 'employeeDetails',
    groupDetails = 'groupDetails',
    userDetails = 'userDetails',
    roleDetails = 'roleDetails',
    myProfile = 'myProfile',
}


export enum StandardFilterTypes {
    SEARCH = 'search',
    DROPDOWN = 'dropdown',
    CHECKBOX = 'checkbox',
}

export enum ReasonsForEntityIsReadOnly {
    CARD_PERMANENT_STATUS = 'CARD_PERMANENT_STATUS',
    ENTITY_IS_OFFBOARDING = 'ENTITY_IS_OFFBOARDING',
    ENTITY_IS_OFFBOARDED = 'ENTITY_IS_OFFBOARDED',
    PARENT_ENTITY_IS_READ_ONLY = 'PARENT_ENTITY_IS_READ_ONLY',
}

export enum ReasonsForBlockedNavigation {
    // forms with own routes
    NOT_PRISTINE_ORDER_CARDS_FORM = 'NOT_PRISTINE_ORDER_CARDS_FORM',

}

export interface DefaultQueryParamsMeta {
    location?: Location,
    timestamp?: number,
}


export const defaultQueryParamsMeta: DefaultQueryParamsMeta = {
    location: undefined,
    timestamp: undefined,
};

export function updateQueryParamsMeta(
    clearTimestamp = false,
    clearLocation = false,
): DefaultQueryParamsMeta {
    return {
        location: clearLocation ? undefined : window.location,
        timestamp: clearTimestamp ? undefined : Date.now(),
    };
}

export function normaliseSortOrderValue(
    sortOrder = '',
) {
    return sortOrder === SortDirections.DESCEND ? SortDirectionsAPI.DESC : SortDirectionsAPI.ASC;
}


export enum AllEntityTypes {
    ACCOUNT = 'ACCOUNT',
    BENEFICIARY = 'BENEFICIARY',
    BUSINESS_USER = 'BUSINESS_USER',
    BUSINESS_SHAREHOLDER = 'BUSINESS_SHAREHOLDER',
    CARD = 'CARD',
    CLIENT = 'CLIENT',
    COMPANY = 'COMPANY',
    FEE = 'FEE',
    GROUP = 'GROUP',
    TRANSACTION = 'TRANSACTION',
    PROMOTION = 'PROMOTION',
    ROLE = 'ROLE',
    PERMISSION = 'PERMISSION',
}


export default {
    APPLICATION_STATE,
    StandardFilterTypes,
    SortDirections,
    DetailsScreensNames,
    ReasonsForBlockedNavigation,
    defaultQueryParamsMeta,
    defaultClipboardContent,
    tabKeySubTabKeySeparator,
};
